var React = require('react');

function ProductsIcon45Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_276","data-name":"Group 276","transform":"translate(-516 -2553)"},[React.createElement("path",{"id":"Path_403","data-name":"Path 403","d":"M25.19,12.35H17.97L15.42,14.9h7.96l-9.31,9.31,1.81,1.81,9.31-9.31v8.3l2.56-2.56V12.35Z","transform":"translate(509.7 2546.77)","key":0}),React.createElement("path",{"id":"Path_404","data-name":"Path 404","d":"M6.3,6.23V24.85h.01l-.01.01,9.52,9.79H20L9.45,23.8V9.38h21.1V23.8L20,34.65h4.18l9.52-9.79-.01-.01h.01V6.23Z","transform":"translate(509.7 2546.77)","key":1})]));
}

ProductsIcon45Inline.defaultProps = {"width":"27.4","height":"28.42","viewBox":"0 0 27.4 28.42"};

module.exports = ProductsIcon45Inline;

ProductsIcon45Inline.default = ProductsIcon45Inline;
